// Hand-crafted human-like translations for Gravats Maresme.
// Languages: es (Spanish), en (English), fr (French), de (German), it (Italian)

export const LANGUAGES = [
  { code: 'es', label: 'ES', name: 'Español' },
  { code: 'en', label: 'EN', name: 'English' },
  { code: 'fr', label: 'FR', name: 'Français' },
  { code: 'de', label: 'DE', name: 'Deutsch' },
  { code: 'it', label: 'IT', name: 'Italiano' },
];

export const translations = {
  // ===================== SPANISH =====================
  es: {
    meta: {
      title: 'Gravats Maresme — Grabado y diseño textil de precisión desde 1981',
      description:
        'Más de 40 años grabando moldes rotativos y planos para la industria textil y del vidrio. Diseño, separaciones de color, muestras, láser, LED, inkjet y consultoría internacional.',
    },
    nav: {
      home: 'Inicio',
      about: 'Empresa',
      services: 'Servicios',
      international: 'Internacional',
      sustainability: 'I+D+i',
      contact: 'Contacto',
      menu: 'Menú',
      close: 'Cerrar',
    },
    cta: {
      contact: 'Contáctanos',
      learnMore: 'Saber más',
      ourServices: 'Nuestros servicios',
      requestInfo: 'Solicitar información',
      getInTouch: 'Hablemos',
      explore: 'Explorar',
      viewAll: 'Ver todos',
    },
    home: {
      kicker: 'Vilassar de Dalt · Barcelona · Desde 1981',
      heroTitle: 'Precisión grabada en cada metro de tejido.',
      heroSub:
        'Cuatro décadas diseñando y grabando moldes rotativos y planos para las marcas textiles y de vidrio más exigentes del mundo.',
      heroLine1: 'Diseño textil · Grabación rotativa · Vidrio arquitectónico',
      stats: [
        { num: '1981', label: 'Año de fundación' },
        { num: '40+', label: 'Años de experiencia' },
        { num: '1.000 m²', label: 'Instalaciones técnicas' },
        { num: '4', label: 'Continentes atendidos' },
      ],
      introKicker: 'Quiénes somos',
      introTitle: 'Una manufactura técnica al servicio del diseño.',
      introBody:
        'Gravats Maresme nace en 1981 a las puertas de Barcelona, en el corazón de la tradición textil catalana. Cuatro décadas después seguimos integrando verticalmente diseño, grabación y muestreo en un mismo taller — y exportando nuestro know-how a Asia, África, Europa y América.',
      servicesKicker: 'Especialidades',
      servicesTitle: 'Una marca a tu lado, de la idea al rapport final.',
      servicesIntro:
        'Combinamos sensibilidad de diseño con tecnología de grabación de última generación: láser, LED, inkjet y software propio de separación.',
      techKicker: 'Tecnología',
      techTitle: 'Equipos pensados para la próxima década, no para la pasada.',
      techBody:
        'Trabajamos con láser de alta resolución, escaneo LED sin fotolito, máquinas inkjet de plana hasta 4000 × 7000 mm y dos equipos LED para rotativa de cualquier rapport.',
      intlKicker: 'Servicio internacional',
      intlTitle: 'Donde haya una estampadora, ahí estamos.',
      intlBody:
        'Llevamos más de una década asesorando talleres en Asia, África y Sudamérica para que alcancen un nivel de calidad europeo, y supervisando la producción de marcas españolas que fabrican fuera.',
      sustainKicker: 'I+D+i · Economía circular',
      sustainTitle: 'Recuperamos lo que la industria solía descartar.',
      sustainBody:
        'Con el apoyo de la Agència de Residus de Catalunya hemos desarrollado dos procesos pioneros — TAKE BACK RECILPACK y TAKE BACK SCREEN FLAT — para devolver la vida útil a cilindros y pantallas que antes se convertían en residuo industrial.',
      finalCtaKicker: 'Hablemos',
      finalCtaTitle: 'Tu próximo diseño merece un grabado a la altura.',
      finalCtaBody:
        'Cuéntanos qué tienes entre manos. Te responderemos en menos de 24 horas con una propuesta clara y técnica.',
    },
    services: {
      kicker: 'Nuestros servicios',
      title: 'Diseño, grabación e ingeniería textil bajo un mismo techo.',
      intro:
        'Siete especialidades coordinadas verticalmente para que tu proyecto llegue al mercado más rápido, mejor y más sostenible.',
      items: [
        {
          n: '01',
          title: 'Diseño textil y originales',
          body:
            'Equipo de diseñadores con software específico, presencia en ferias internacionales y un radar permanentemente conectado a las tendencias del momento.',
        },
        {
          n: '02',
          title: 'Grabación rotativa',
          body:
            'Cilindros para rotativa grabados con láser y LED, capaces de reproducir rapports complejos con una constancia milimétrica producción tras producción.',
        },
        {
          n: '03',
          title: 'Grabación plana e inkjet',
          body:
            'Máquinas de plana inkjet hasta 4000 × 7000 mm para pantallas de cualquier formato — incluyendo trabajos en serigrafía técnica de alta precisión.',
        },
        {
          n: '04',
          title: 'Separación de colores y rapports',
          body:
            'Software propio para separar, ajustar y validar coloridos. Entregamos archivos listos para grabar o para que tus equipos hagan variantes cromáticas.',
        },
        {
          n: '05',
          title: 'Muestras, digital y 3D mapping',
          body:
            'Departamento interno de muestras físicas, sublimación digital y simulación 3D mapping para visualizar el estampado sobre prenda antes de grabar.',
        },
        {
          n: '06',
          title: 'Vidrio arquitectónico y automoción',
          body:
            'División específica de pantallas para vidrio, sin fotolitos, con tecnología LED hasta 4000 × 7000 mm. Acabados para fachadas y para la industria del automóvil.',
        },
        {
          n: '07',
          title: 'Consultoría y control de calidad',
          body:
            'Más de diez años transfiriendo know-how a talleres internacionales y auditando la calidad de estampaciones para marcas españolas que fabrican fuera.',
        },
      ],
    },
    about: {
      kicker: 'La empresa',
      title: 'Cuarenta años convirtiendo el grabado en un oficio de precisión.',
      intro:
        'Fundada en 1981 en Vilassar de Dalt, a las puertas de Barcelona, Gravats Maresme nació en el centro de una de las áreas textiles más activas de Europa. Desde entonces, hemos hecho una sola cosa muy bien: grabar moldes y diseñar para que los grandes nombres del textil puedan imprimir mejor.',
      timelineTitle: 'Una historia hecha de máquinas, manos y madrugadas.',
      timeline: [
        {
          year: '1981',
          title: 'Fundación en Vilassar de Dalt',
          body:
            'Arrancamos como un pequeño taller especializado en la grabación lyonesa y rotativa, sirviendo a las estampadoras del Maresme.',
        },
        {
          year: '1995',
          title: 'Integración vertical',
          body:
            'Incorporamos el departamento interno de diseño y separación de colores para entregar el rapport listo para producción.',
        },
        {
          year: '2008',
          title: 'Apertura internacional',
          body:
            'Empezamos a asesorar estampadoras en Asia, África y Sudamérica para que alcancen estándares europeos de calidad.',
        },
        {
          year: '2015',
          title: 'Tecnología láser y LED',
          body:
            'Renovamos por completo el parque de máquinas con grabación láser y LED sin fotolitos hasta 4000 × 7000 mm.',
        },
        {
          year: '2020',
          title: 'I+D+i y economía circular',
          body:
            'Con el apoyo de la Agència de Residus de Catalunya lanzamos los proyectos TAKE BACK RECILPACK y TAKE BACK SCREEN FLAT.',
        },
        {
          year: 'Hoy',
          title: '1.000 m² verticales en Barcelona',
          body:
            'Diseñamos, grabamos y simulamos en el mismo edificio — para entregar más rápido, con menos margen de error y más cerca del cliente.',
        },
      ],
      facilitiesKicker: 'Instalaciones',
      facilitiesTitle: '1.000 m² en el corazón textil del Maresme.',
      facilitiesBody:
        'Diseño, separación, grabación rotativa, grabación plana, muestreo digital, 3D mapping y vidrio: todo en la misma planta. Esa integración es lo que nos permite responder en horas, no en semanas.',
    },
    international: {
      kicker: 'Servicio internacional',
      title: 'Una empresa catalana con clientes en cuatro continentes.',
      intro:
        'Llevamos más de una década transfiriendo nuestro know-how a talleres y marcas fuera de España. Lo hacemos con un objetivo claro: que la estampación que se produce a 9.000 kilómetros tenga la misma calidad que la que sale de Vilassar.',
      regions: [
        {
          name: 'Europa',
          body: 'Producción local con marcas italianas, francesas, portuguesas y alemanas.',
        },
        {
          name: 'Asia',
          body: 'Transferencia técnica a estampadoras en Turquía, India, China y Vietnam.',
        },
        {
          name: 'África',
          body: 'Consultoría y auditoría de calidad para nuevos polos textiles en el norte y oeste del continente.',
        },
        {
          name: 'Sudamérica',
          body: 'Acompañamiento técnico a talleres en Brasil, Colombia y Perú.',
        },
      ],
      capabilitiesTitle: 'Cómo trabajamos a distancia.',
      capabilities: [
        'Transferencia de know-how y formación de equipos técnicos in situ.',
        'Control de calidad para marcas españolas que fabrican fuera.',
        'Auditoría y puesta a punto de salas de grabación.',
        'Suministro remoto de archivos de separación y rapports listos para producción.',
      ],
    },
    sustainability: {
      kicker: 'I+D+i · Economía circular',
      title: 'Convertimos residuo industrial en recurso productivo.',
      intro:
        'No creemos en la sostenibilidad de etiqueta. Creemos en procesos verificados, premiados por la Agència de Residus de Catalunya, que reducen toneladas de CO₂ por cilindro recuperado.',
      projects: [
        {
          code: 'TES/3340/2020',
          name: 'TAKE BACK RECILPACK',
          body:
            'Recuperación de cilindros de anilox usados en la estampación de packaging mediante lavado con agua a presión, sin productos químicos. Recuperación mínima del 90% de la capacidad de las microceldas y un ahorro de 1,4 toneladas de CO₂ por cilindro frente a fabricar uno nuevo.',
          benefits: [
            'Ecológico: solo agua, cero residuos peligrosos.',
            'Eficaz: ≥90% de microceldas recuperadas.',
            'Económico: menos coste de operación frente a métodos tradicionales.',
            'Rápido: menos tiempos muertos en la línea de estampación.',
          ],
        },
        {
          code: 'ACC/3352/2022',
          name: 'TAKE BACK SCREEN FLAT',
          body:
            'Proyecto de recuperación de pantallas planas en desuso para reintegrarlas en el proceso de estampación textil. Una segunda vida útil para un material que tradicionalmente se desechaba.',
          benefits: [
            'Menos consumo de materia prima.',
            'Reducción directa de residuos industriales.',
            'Reintegración inmediata en producción.',
            'Trazabilidad completa del ciclo.',
          ],
        },
      ],
      partnership:
        'Ambos proyectos cuentan con el apoyo de la Agència de Residus de Catalunya, dentro de la línea de Ajuts per a projectes de foment de l’economia circular.',
    },
    contact: {
      kicker: 'Hablemos',
      title: 'Empieza un proyecto con nosotros.',
      intro:
        'Cuéntanos qué necesitas grabar, separar o muestrear. Te responderemos en menos de 24 horas con una propuesta concreta.',
      form: {
        name: 'Nombre',
        email: 'Email',
        company: 'Empresa',
        phone: 'Teléfono',
        subject: 'Asunto',
        message: 'Mensaje',
        send: 'Enviar mensaje',
        sending: 'Enviando…',
        successTitle: 'Mensaje enviado',
        successBody: 'Gracias. Te responderemos en menos de 24 horas.',
        errorTitle: 'No se ha podido enviar',
        errorBody: 'Inténtalo de nuevo o escríbenos directamente a info@gravatsmaresme.com.',
        requiredName: 'Indica tu nombre.',
        requiredEmail: 'Introduce un email válido.',
        requiredMessage: 'Cuéntanos en qué podemos ayudarte.',
      },
      info: {
        addressLabel: 'Dirección',
        address: 'C/ Manuel Ventura Campeny, 8\n08339 Vilassar de Dalt — Barcelona (España)',
        phoneLabel: 'Teléfono',
        emailLabel: 'Email',
        hoursLabel: 'Horario',
        hours: 'Lun – Vie · 8:00 – 18:00 CET',
      },
    },
    footer: {
      tagline: 'Diseño y grabación textil de precisión. Desde 1981.',
      navTitle: 'Navegación',
      contactTitle: 'Contacto',
      legalTitle: 'Legal',
      privacy: 'Política de privacidad',
      cookies: 'Cookies',
      rights: '© {year} Gravats Maresme, S.L. — Todos los derechos reservados.',
      etrade:
        'Proyecto impulsado por el Programa International e-Trade de ACCIÓ, Generalitat de Catalunya.',
    },
  },

  // ===================== ENGLISH =====================
  en: {
    meta: {
      title: 'Gravats Maresme — Precision textile engraving and design since 1981',
      description:
        'Over forty years engraving rotary and flat screens for the textile and glass printing industries. Design, color separation, sampling, laser, LED, inkjet and international consulting.',
    },
    nav: {
      home: 'Home',
      about: 'Company',
      services: 'Services',
      international: 'International',
      sustainability: 'R&D',
      contact: 'Contact',
      menu: 'Menu',
      close: 'Close',
    },
    cta: {
      contact: 'Contact us',
      learnMore: 'Learn more',
      ourServices: 'Our services',
      requestInfo: 'Request information',
      getInTouch: 'Get in touch',
      explore: 'Explore',
      viewAll: 'View all',
    },
    home: {
      kicker: 'Vilassar de Dalt · Barcelona · Since 1981',
      heroTitle: 'Precision engraved into every metre of fabric.',
      heroSub:
        'For four decades we have designed and engraved rotary and flat screens for some of the most demanding textile and glass printing brands in the world.',
      heroLine1: 'Textile design · Rotary engraving · Architectural glass',
      stats: [
        { num: '1981', label: 'Founded in' },
        { num: '40+', label: 'Years of expertise' },
        { num: '1,000 m²', label: 'Technical facility' },
        { num: '4', label: 'Continents served' },
      ],
      introKicker: 'Who we are',
      introTitle: 'A technical workshop in the service of design.',
      introBody:
        'Gravats Maresme was founded in 1981 on the outskirts of Barcelona, in the heart of the Catalan textile tradition. Four decades on, we still combine design, engraving and sampling under one roof — and export that know-how to Asia, Africa, Europe and the Americas.',
      servicesKicker: 'Specialities',
      servicesTitle: 'A partner from the first sketch to the final rapport.',
      servicesIntro:
        'Design sensibility meets state-of-the-art engraving technology: laser, LED, inkjet and proprietary separation software.',
      techKicker: 'Technology',
      techTitle: 'Equipment built for the next decade, not the previous one.',
      techBody:
        'High-resolution laser, photolith-free LED scanning, flat inkjet machines up to 4,000 × 7,000 mm and two LED rotary engravers ready for any repeat.',
      intlKicker: 'International service',
      intlTitle: 'Wherever there is a printing line, we are there.',
      intlBody:
        'For more than a decade we have helped workshops in Asia, Africa and South America reach European quality levels, and we audit production for Spanish brands manufacturing abroad.',
      sustainKicker: 'R&D · Circular economy',
      sustainTitle: 'We recover what the industry used to throw away.',
      sustainBody:
        'With support from the Catalan Waste Agency we have developed two pioneering processes — TAKE BACK RECILPACK and TAKE BACK SCREEN FLAT — that bring used cylinders and flat screens back into productive life.',
      finalCtaKicker: 'Let’s talk',
      finalCtaTitle: 'Your next design deserves engraving that matches it.',
      finalCtaBody:
        'Tell us what you are working on. We will reply within 24 hours with a clear, technical proposal.',
    },
    services: {
      kicker: 'Our services',
      title: 'Design, engraving and textile engineering under one roof.',
      intro:
        'Seven vertically coordinated specialities so your project reaches the market faster, better and more sustainably.',
      items: [
        {
          n: '01',
          title: 'Textile design & originals',
          body:
            'In-house designers backed by dedicated software, regular presence at international fairs and a constant pulse on emerging trends.',
        },
        {
          n: '02',
          title: 'Rotary engraving',
          body:
            'Rotary cylinders engraved with laser and LED, reproducing complex repeats with millimetric consistency run after run.',
        },
        {
          n: '03',
          title: 'Flat engraving & inkjet',
          body:
            'Flat inkjet machines up to 4,000 × 7,000 mm for screens of any size — including high-precision technical screen printing.',
        },
        {
          n: '04',
          title: 'Color separation & repeats',
          body:
            'Proprietary software to separate, fine-tune and validate colorways. Files delivered ready for engraving or for in-house variants.',
        },
        {
          n: '05',
          title: 'Sampling, digital & 3D mapping',
          body:
            'Internal department for physical samples, digital sublimation and 3D mapping to preview prints on garment before engraving.',
        },
        {
          n: '06',
          title: 'Architectural & automotive glass',
          body:
            'Dedicated glass screen division, photolith-free LED technology up to 4,000 × 7,000 mm. Finishes for façades and automotive industry.',
        },
        {
          n: '07',
          title: 'Consulting & quality control',
          body:
            'Over a decade transferring know-how to international workshops and auditing print quality for Spanish brands producing offshore.',
        },
      ],
    },
    about: {
      kicker: 'The company',
      title: 'Forty years turning engraving into a craft of precision.',
      intro:
        'Founded in 1981 in Vilassar de Dalt, at the gates of Barcelona, Gravats Maresme was born in the centre of one of the most active textile regions in Europe. Since then we have done one thing very well: engrave screens and design so the great names of textile can print better.',
      timelineTitle: 'A history of machines, hands and early mornings.',
      timeline: [
        {
          year: '1981',
          title: 'Founded in Vilassar de Dalt',
          body:
            'We started as a small workshop specialising in lyonnaise and rotary engraving, serving printers across the Maresme region.',
        },
        {
          year: '1995',
          title: 'Vertical integration',
          body:
            'We added the in-house design and color separation department so the rapport leaves the building production-ready.',
        },
        {
          year: '2008',
          title: 'International expansion',
          body:
            'We began advising printers in Asia, Africa and South America to reach European quality standards.',
        },
        {
          year: '2015',
          title: 'Laser & LED technology',
          body:
            'We rebuilt our entire engraving park around photolith-free laser and LED engraving up to 4,000 × 7,000 mm.',
        },
        {
          year: '2020',
          title: 'R&D and circular economy',
          body:
            'With support from the Catalan Waste Agency we launched the TAKE BACK RECILPACK and TAKE BACK SCREEN FLAT programs.',
        },
        {
          year: 'Today',
          title: '1,000 m² in the textile heart of Catalonia',
          body:
            'Design, separation, rotary, flat, sampling and glass — all under one roof. That integration is what lets us answer in hours, not weeks.',
        },
      ],
      facilitiesKicker: 'Facilities',
      facilitiesTitle: '1,000 m² in the textile heart of Maresme.',
      facilitiesBody:
        'Design, separation, rotary engraving, flat engraving, digital sampling, 3D mapping and glass — all on the same floor. That vertical integration is what allows us to respond in hours, not weeks.',
    },
    international: {
      kicker: 'International service',
      title: 'A Catalan company with clients on four continents.',
      intro:
        'For over a decade we have transferred our know-how to workshops and brands beyond Spain. We do it with one clear goal: that printing produced 9,000 km away meets the same standard as printing leaving Vilassar.',
      regions: [
        {
          name: 'Europe',
          body: 'Local production with Italian, French, Portuguese and German brands.',
        },
        {
          name: 'Asia',
          body: 'Technical transfer to printers in Türkiye, India, China and Vietnam.',
        },
        {
          name: 'Africa',
          body: 'Consulting and quality auditing for emerging textile clusters in North and West Africa.',
        },
        {
          name: 'South America',
          body: 'Technical support for workshops in Brazil, Colombia and Peru.',
        },
      ],
      capabilitiesTitle: 'How we operate at a distance.',
      capabilities: [
        'Know-how transfer and on-site training of technical teams.',
        'Quality control for Spanish brands manufacturing offshore.',
        'Audit and tuning of engraving rooms.',
        'Remote delivery of separation files and production-ready repeats.',
      ],
    },
    sustainability: {
      kicker: 'R&D · Circular economy',
      title: 'We turn industrial waste back into productive resource.',
      intro:
        'We do not believe in label-deep sustainability. We believe in verified, awarded processes that cut tonnes of CO₂ for every cylinder we recover.',
      projects: [
        {
          code: 'TES/3340/2020',
          name: 'TAKE BACK RECILPACK',
          body:
            'Recovery of anilox cylinders used in packaging printing through pressurised water washing — no chemicals. Minimum 90% recovery of microcell capacity and a saving of 1.4 tonnes of CO₂ per cylinder versus manufacturing a new one.',
          benefits: [
            'Ecological: water only, zero hazardous waste.',
            'Effective: ≥90% microcell recovery.',
            'Economical: lower operating cost than traditional methods.',
            'Fast: less downtime on the printing line.',
          ],
        },
        {
          code: 'ACC/3352/2022',
          name: 'TAKE BACK SCREEN FLAT',
          body:
            'Recovery program for disused flat screens to bring them back into the textile printing process. A second productive life for material traditionally discarded.',
          benefits: [
            'Lower raw material consumption.',
            'Direct reduction of industrial waste.',
            'Immediate reintegration into production.',
            'Full lifecycle traceability.',
          ],
        },
      ],
      partnership:
        'Both projects are supported by the Catalan Waste Agency under its circular economy grant programme.',
    },
    contact: {
      kicker: 'Let’s talk',
      title: 'Start a project with us.',
      intro:
        'Tell us what you need to engrave, separate or sample. We will reply within 24 hours with a concrete proposal.',
      form: {
        name: 'Name',
        email: 'Email',
        company: 'Company',
        phone: 'Phone',
        subject: 'Subject',
        message: 'Message',
        send: 'Send message',
        sending: 'Sending…',
        successTitle: 'Message sent',
        successBody: 'Thank you. We will reply within 24 hours.',
        errorTitle: 'Could not send',
        errorBody: 'Please try again or write us directly at info@gravatsmaresme.com.',
        requiredName: 'Please enter your name.',
        requiredEmail: 'Please enter a valid email.',
        requiredMessage: 'Tell us how we can help.',
      },
      info: {
        addressLabel: 'Address',
        address: 'C/ Manuel Ventura Campeny, 8\n08339 Vilassar de Dalt — Barcelona (Spain)',
        phoneLabel: 'Phone',
        emailLabel: 'Email',
        hoursLabel: 'Hours',
        hours: 'Mon – Fri · 8:00 – 18:00 CET',
      },
    },
    footer: {
      tagline: 'Precision textile design and engraving. Since 1981.',
      navTitle: 'Navigation',
      contactTitle: 'Contact',
      legalTitle: 'Legal',
      privacy: 'Privacy policy',
      cookies: 'Cookies',
      rights: '© {year} Gravats Maresme, S.L. — All rights reserved.',
      etrade:
        'Project supported by the International e-Trade Programme of ACCIÓ, Generalitat de Catalunya.',
    },
  },

  // ===================== FRENCH =====================
  fr: {
    meta: {
      title: 'Gravats Maresme — Gravure et design textile de précision depuis 1981',
      description:
        'Plus de quarante ans de gravure de cadres rotatifs et plats pour l’industrie de l’impression textile et du verre. Design, séparation couleur, échantillons, laser, LED, inkjet et conseil international.',
    },
    nav: {
      home: 'Accueil',
      about: 'L’entreprise',
      services: 'Services',
      international: 'International',
      sustainability: 'R&D',
      contact: 'Contact',
      menu: 'Menu',
      close: 'Fermer',
    },
    cta: {
      contact: 'Nous contacter',
      learnMore: 'En savoir plus',
      ourServices: 'Nos services',
      requestInfo: 'Demander une information',
      getInTouch: 'Échangeons',
      explore: 'Explorer',
      viewAll: 'Tout voir',
    },
    home: {
      kicker: 'Vilassar de Dalt · Barcelone · Depuis 1981',
      heroTitle: 'La précision gravée dans chaque mètre de tissu.',
      heroSub:
        'Quarante ans à dessiner et graver des cadres rotatifs et plats pour les marques textiles et verrières les plus exigeantes au monde.',
      heroLine1: 'Design textile · Gravure rotative · Verre architectural',
      stats: [
        { num: '1981', label: 'Année de fondation' },
        { num: '40+', label: 'Années d’expérience' },
        { num: '1 000 m²', label: 'Atelier technique' },
        { num: '4', label: 'Continents desservis' },
      ],
      introKicker: 'Qui sommes-nous',
      introTitle: 'Une manufacture technique au service du design.',
      introBody:
        'Gravats Maresme a vu le jour en 1981 aux portes de Barcelone, au cœur de la tradition textile catalane. Quarante ans plus tard, nous réunissons toujours design, gravure et échantillonnage sous un même toit — et exportons notre savoir-faire en Asie, en Afrique, en Europe et en Amérique.',
      servicesKicker: 'Spécialités',
      servicesTitle: 'Un partenaire à vos côtés, du croquis au rapport final.',
      servicesIntro:
        'Sensibilité créative et technologie de gravure de pointe : laser, LED, inkjet et logiciel propriétaire de séparation.',
      techKicker: 'Technologie',
      techTitle: 'Des équipements pensés pour la prochaine décennie, pas la précédente.',
      techBody:
        'Laser haute résolution, gravure LED sans typon, machines inkjet plates jusqu’à 4 000 × 7 000 mm et deux unités LED pour rotative, tous rapports confondus.',
      intlKicker: 'Service international',
      intlTitle: 'Là où il y a une ligne d’impression, nous sommes là.',
      intlBody:
        'Depuis plus de dix ans, nous accompagnons les ateliers d’Asie, d’Afrique et d’Amérique du Sud pour atteindre les standards européens — et nous auditons la production des marques espagnoles fabriquant à l’étranger.',
      sustainKicker: 'R&D · Économie circulaire',
      sustainTitle: 'Nous récupérons ce que l’industrie jetait.',
      sustainBody:
        'Avec le soutien de l’Agence des Déchets de Catalogne, nous avons développé deux procédés pionniers — TAKE BACK RECILPACK et TAKE BACK SCREEN FLAT — qui redonnent vie aux cylindres et cadres usés.',
      finalCtaKicker: 'Parlons-en',
      finalCtaTitle: 'Votre prochain motif mérite une gravure à sa hauteur.',
      finalCtaBody:
        'Dites-nous sur quoi vous travaillez. Nous répondrons sous 24 heures avec une proposition claire et technique.',
    },
    services: {
      kicker: 'Nos services',
      title: 'Design, gravure et ingénierie textile sous un même toit.',
      intro:
        'Sept spécialités intégrées verticalement pour que votre projet arrive sur le marché plus vite, mieux et plus durablement.',
      items: [
        {
          n: '01',
          title: 'Design textile & originaux',
          body:
            'Designers internes, logiciel dédié, présence régulière dans les salons internationaux et une veille permanente des tendances.',
        },
        {
          n: '02',
          title: 'Gravure rotative',
          body:
            'Cylindres gravés au laser et à la LED, reproduisant des rapports complexes avec une régularité millimétrique d’une production à l’autre.',
        },
        {
          n: '03',
          title: 'Gravure plate & inkjet',
          body:
            'Machines plates inkjet jusqu’à 4 000 × 7 000 mm pour cadres de toute taille, sérigraphie technique haute précision incluse.',
        },
        {
          n: '04',
          title: 'Séparation couleur & rapports',
          body:
            'Logiciel maison pour séparer, ajuster et valider les coloris. Fichiers livrés prêts à graver ou pour générer des variantes en interne.',
        },
        {
          n: '05',
          title: 'Échantillons, digital & 3D mapping',
          body:
            'Service interne d’échantillons physiques, sublimation digitale et 3D mapping pour visualiser l’imprimé sur le vêtement avant gravure.',
        },
        {
          n: '06',
          title: 'Verre architectural & automobile',
          body:
            'Division dédiée à la sérigraphie sur verre, technologie LED sans typon jusqu’à 4 000 × 7 000 mm. Finitions pour façades et industrie automobile.',
        },
        {
          n: '07',
          title: 'Conseil & contrôle qualité',
          body:
            'Plus de dix ans de transfert de savoir-faire aux ateliers internationaux et d’audit qualité pour les marques espagnoles produisant à l’étranger.',
        },
      ],
    },
    about: {
      kicker: 'L’entreprise',
      title: 'Quarante ans à faire de la gravure un métier de précision.',
      intro:
        'Fondée en 1981 à Vilassar de Dalt, aux portes de Barcelone, Gravats Maresme est née au centre de l’une des zones textiles les plus actives d’Europe. Depuis, nous faisons une seule chose très bien : graver et dessiner pour que les grands noms du textile impriment mieux.',
      timelineTitle: 'Une histoire de machines, de mains et de matins.',
      timeline: [
        {
          year: '1981',
          title: 'Fondation à Vilassar de Dalt',
          body:
            'Nous démarrons comme un petit atelier spécialisé dans la gravure lyonnaise et rotative, au service des imprimeurs du Maresme.',
        },
        {
          year: '1995',
          title: 'Intégration verticale',
          body:
            'Création du département interne de design et séparation couleur : le rapport sort de l’atelier prêt pour la production.',
        },
        {
          year: '2008',
          title: 'Ouverture internationale',
          body:
            'Nous commençons à conseiller des imprimeurs en Asie, en Afrique et en Amérique du Sud pour atteindre les standards européens.',
        },
        {
          year: '2015',
          title: 'Technologies laser & LED',
          body:
            'Rénovation complète du parc machines : gravure laser et LED sans typon jusqu’à 4 000 × 7 000 mm.',
        },
        {
          year: '2020',
          title: 'R&D et économie circulaire',
          body:
            'Avec l’Agence des Déchets de Catalogne, lancement des projets TAKE BACK RECILPACK et TAKE BACK SCREEN FLAT.',
        },
        {
          year: 'Aujourd’hui',
          title: '1 000 m² intégrés au cœur textile de Catalogne',
          body:
            'Design, séparation, rotative, plat, échantillonnage, 3D mapping et verre : tout est sous le même toit.',
        },
      ],
      facilitiesKicker: 'Installations',
      facilitiesTitle: '1 000 m² au cœur textile du Maresme.',
      facilitiesBody:
        'Design, séparation, gravure rotative, gravure plate, échantillonnage digital, 3D mapping et verre : tout est dans le même bâtiment. Cette intégration nous permet de répondre en heures, pas en semaines.',
    },
    international: {
      kicker: 'Service international',
      title: 'Une entreprise catalane avec des clients sur quatre continents.',
      intro:
        'Depuis plus de dix ans, nous transférons notre savoir-faire à des ateliers et marques au-delà de l’Espagne. Avec un objectif clair : que ce qui s’imprime à 9 000 km respecte le même niveau de qualité que ce qui sort de Vilassar.',
      regions: [
        { name: 'Europe', body: 'Production locale avec des marques italiennes, françaises, portugaises et allemandes.' },
        { name: 'Asie', body: 'Transfert technique vers des imprimeurs en Turquie, Inde, Chine et Vietnam.' },
        { name: 'Afrique', body: 'Conseil et audit qualité pour les pôles textiles émergents d’Afrique du Nord et de l’Ouest.' },
        { name: 'Amérique du Sud', body: 'Accompagnement technique d’ateliers au Brésil, en Colombie et au Pérou.' },
      ],
      capabilitiesTitle: 'Notre manière de travailler à distance.',
      capabilities: [
        'Transfert de savoir-faire et formation des équipes techniques sur place.',
        'Contrôle qualité pour les marques espagnoles fabriquant à l’étranger.',
        'Audit et mise au point des salles de gravure.',
        'Livraison à distance des fichiers de séparation et des rapports prêts à produire.',
      ],
    },
    sustainability: {
      kicker: 'R&D · Économie circulaire',
      title: 'Nous transformons le déchet industriel en ressource productive.',
      intro:
        'Pas de durabilité d’étiquette. Des procédés vérifiés, primés par l’Agence des Déchets de Catalogne, qui économisent des tonnes de CO₂ par cylindre récupéré.',
      projects: [
        {
          code: 'TES/3340/2020',
          name: 'TAKE BACK RECILPACK',
          body:
            'Récupération des cylindres anilox utilisés dans l’impression d’emballages par lavage à l’eau sous pression, sans produit chimique. Au moins 90 % de la capacité des microcellules récupérée et 1,4 tonne de CO₂ économisée par cylindre face à la fabrication d’un neuf.',
          benefits: [
            'Écologique : uniquement de l’eau, zéro déchet dangereux.',
            'Efficace : ≥ 90 % des microcellules récupérées.',
            'Économique : coût d’exploitation inférieur aux méthodes traditionnelles.',
            'Rapide : moins d’arrêts sur la ligne d’impression.',
          ],
        },
        {
          code: 'ACC/3352/2022',
          name: 'TAKE BACK SCREEN FLAT',
          body:
            'Programme de récupération des cadres plats hors d’usage pour les réinjecter dans le processus d’impression textile. Une seconde vie productive pour un matériau autrefois jeté.',
          benefits: [
            'Moins de matière première consommée.',
            'Réduction directe des déchets industriels.',
            'Réintégration immédiate en production.',
            'Traçabilité complète du cycle.',
          ],
        },
      ],
      partnership:
        'Les deux projets sont soutenus par l’Agence des Déchets de Catalogne, dans le cadre de son programme d’aide à l’économie circulaire.',
    },
    contact: {
      kicker: 'Échangeons',
      title: 'Démarrez un projet avec nous.',
      intro:
        'Dites-nous ce que vous devez graver, séparer ou échantillonner. Nous répondons sous 24 heures avec une proposition concrète.',
      form: {
        name: 'Nom',
        email: 'E-mail',
        company: 'Société',
        phone: 'Téléphone',
        subject: 'Objet',
        message: 'Message',
        send: 'Envoyer le message',
        sending: 'Envoi…',
        successTitle: 'Message envoyé',
        successBody: 'Merci. Nous vous répondons sous 24 heures.',
        errorTitle: 'Envoi impossible',
        errorBody: 'Réessayez ou écrivez-nous à info@gravatsmaresme.com.',
        requiredName: 'Indiquez votre nom.',
        requiredEmail: 'Entrez un e-mail valide.',
        requiredMessage: 'Dites-nous comment nous pouvons aider.',
      },
      info: {
        addressLabel: 'Adresse',
        address: 'C/ Manuel Ventura Campeny, 8\n08339 Vilassar de Dalt — Barcelone (Espagne)',
        phoneLabel: 'Téléphone',
        emailLabel: 'E-mail',
        hoursLabel: 'Horaires',
        hours: 'Lun – Ven · 8h00 – 18h00 CET',
      },
    },
    footer: {
      tagline: 'Design et gravure textile de précision. Depuis 1981.',
      navTitle: 'Navigation',
      contactTitle: 'Contact',
      legalTitle: 'Mentions',
      privacy: 'Politique de confidentialité',
      cookies: 'Cookies',
      rights: '© {year} Gravats Maresme, S.L. — Tous droits réservés.',
      etrade: 'Projet soutenu par le Programme International e-Trade d’ACCIÓ, Generalitat de Catalunya.',
    },
  },

  // ===================== GERMAN =====================
  de: {
    meta: {
      title: 'Gravats Maresme — Präzisionsgravur und Textildesign seit 1981',
      description:
        'Über vierzig Jahre Erfahrung in der Gravur von Rund- und Flachschablonen für den Textil- und Glasdruck. Design, Farbseparation, Musterbau, Laser-, LED-, Inkjet- und internationale Beratung.',
    },
    nav: {
      home: 'Start',
      about: 'Unternehmen',
      services: 'Leistungen',
      international: 'International',
      sustainability: 'F&E',
      contact: 'Kontakt',
      menu: 'Menü',
      close: 'Schließen',
    },
    cta: {
      contact: 'Kontakt aufnehmen',
      learnMore: 'Mehr erfahren',
      ourServices: 'Unsere Leistungen',
      requestInfo: 'Information anfragen',
      getInTouch: 'Sprechen wir',
      explore: 'Entdecken',
      viewAll: 'Alle ansehen',
    },
    home: {
      kicker: 'Vilassar de Dalt · Barcelona · Seit 1981',
      heroTitle: 'Präzision, eingraviert in jeden Meter Stoff.',
      heroSub:
        'Vier Jahrzehnte Design und Gravur von Rund- und Flachschablonen für einige der anspruchsvollsten Textil- und Glasdruckmarken weltweit.',
      heroLine1: 'Textildesign · Rotationsgravur · Architekturglas',
      stats: [
        { num: '1981', label: 'Gegründet' },
        { num: '40+', label: 'Jahre Erfahrung' },
        { num: '1.000 m²', label: 'Technische Anlage' },
        { num: '4', label: 'Kontinente' },
      ],
      introKicker: 'Wer wir sind',
      introTitle: 'Eine technische Manufaktur im Dienst des Designs.',
      introBody:
        'Gravats Maresme wurde 1981 vor den Toren Barcelonas gegründet — mitten in einer der aktivsten Textilregionen Europas. Seither vereinen wir Design, Gravur und Musterbau unter einem Dach und exportieren dieses Know-how nach Asien, Afrika, Europa und Amerika.',
      servicesKicker: 'Spezialgebiete',
      servicesTitle: 'Ein Partner von der ersten Skizze bis zum finalen Rapport.',
      servicesIntro:
        'Gestaltungssinn trifft auf modernste Gravurtechnologie: Laser, LED, Inkjet und proprietäre Separationssoftware.',
      techKicker: 'Technologie',
      techTitle: 'Maschinen für das nächste Jahrzehnt, nicht das vergangene.',
      techBody:
        'Hochauflösender Laser, filmlose LED-Belichtung, Flach-Inkjet bis 4.000 × 7.000 mm und zwei LED-Anlagen für Rotationszylinder jeder Rapportgröße.',
      intlKicker: 'Internationaler Service',
      intlTitle: 'Wo gedruckt wird, sind wir dabei.',
      intlBody:
        'Seit über zehn Jahren unterstützen wir Werkstätten in Asien, Afrika und Südamerika dabei, europäisches Qualitätsniveau zu erreichen — und auditieren die Produktion spanischer Marken im Ausland.',
      sustainKicker: 'F&E · Kreislaufwirtschaft',
      sustainTitle: 'Wir holen zurück, was die Industrie wegwarf.',
      sustainBody:
        'Mit Unterstützung der katalanischen Abfallagentur haben wir zwei wegweisende Verfahren entwickelt — TAKE BACK RECILPACK und TAKE BACK SCREEN FLAT — die gebrauchte Zylinder und Flachschablonen zurück in den Produktionskreislauf bringen.',
      finalCtaKicker: 'Sprechen wir',
      finalCtaTitle: 'Ihr nächstes Design verdient eine Gravur auf Augenhöhe.',
      finalCtaBody:
        'Erzählen Sie uns von Ihrem Projekt. Wir antworten innerhalb von 24 Stunden mit einem klaren, technischen Vorschlag.',
    },
    services: {
      kicker: 'Unsere Leistungen',
      title: 'Design, Gravur und Textiltechnik unter einem Dach.',
      intro:
        'Sieben vertikal koordinierte Disziplinen, damit Ihr Projekt schneller, besser und nachhaltiger auf den Markt kommt.',
      items: [
        {
          n: '01',
          title: 'Textildesign & Originale',
          body:
            'Inhouse-Designteam mit Spezialsoftware, regelmäßiger Präsenz auf internationalen Messen und ständigem Trendradar.',
        },
        {
          n: '02',
          title: 'Rotationsgravur',
          body:
            'Mit Laser und LED gravierte Rundschablonen, die komplexe Rapporte millimetergenau und produktionsstabil wiedergeben.',
        },
        {
          n: '03',
          title: 'Flachgravur & Inkjet',
          body:
            'Flach-Inkjet-Maschinen bis 4.000 × 7.000 mm für Schablonen jeder Größe — inklusive technischer Hochpräzisionssiebe.',
        },
        {
          n: '04',
          title: 'Farbseparation & Rapporte',
          body:
            'Eigene Software zur Trennung, Feinjustage und Validierung von Farbstellungen. Dateien fertig zur Gravur oder für interne Varianten.',
        },
        {
          n: '05',
          title: 'Muster, Digitaldruck & 3D-Mapping',
          body:
            'Internes Musterstudio für physische Muster, digitale Sublimation und 3D-Mapping zur Vorschau auf das fertige Kleidungsstück.',
        },
        {
          n: '06',
          title: 'Architektur- & Automobilglas',
          body:
            'Eigene Abteilung für Glassiebe, filmlose LED-Technologie bis 4.000 × 7.000 mm. Veredelungen für Fassaden und die Autoindustrie.',
        },
        {
          n: '07',
          title: 'Beratung & Qualitätskontrolle',
          body:
            'Mehr als ein Jahrzehnt Know-how-Transfer für internationale Werkstätten und Qualitätsaudits für spanische Marken mit Offshore-Produktion.',
        },
      ],
    },
    about: {
      kicker: 'Das Unternehmen',
      title: 'Vierzig Jahre, in denen Gravur zum Präzisionshandwerk wurde.',
      intro:
        '1981 in Vilassar de Dalt vor den Toren Barcelonas gegründet, ist Gravats Maresme im Zentrum einer der aktivsten Textilregionen Europas entstanden. Seither tun wir eine Sache sehr gut: gravieren und gestalten — damit die großen Namen der Textilbranche besser drucken.',
      timelineTitle: 'Eine Geschichte aus Maschinen, Händen und frühen Morgenstunden.',
      timeline: [
        { year: '1981', title: 'Gründung in Vilassar de Dalt', body: 'Start als kleine Werkstatt für Lyoneser und Rotationsgravur im Dienst der Druckereien des Maresme.' },
        { year: '1995', title: 'Vertikale Integration', body: 'Wir bauen die interne Design- und Separationsabteilung auf — der Rapport verlässt das Haus produktionsfertig.' },
        { year: '2008', title: 'Internationale Öffnung', body: 'Wir beraten Druckereien in Asien, Afrika und Südamerika auf dem Weg zu europäischen Qualitätsstandards.' },
        { year: '2015', title: 'Laser- und LED-Technologie', body: 'Komplette Erneuerung des Maschinenparks: filmlose Laser- und LED-Gravur bis 4.000 × 7.000 mm.' },
        { year: '2020', title: 'F&E und Kreislaufwirtschaft', body: 'Mit der katalanischen Abfallagentur starten wir TAKE BACK RECILPACK und TAKE BACK SCREEN FLAT.' },
        { year: 'Heute', title: '1.000 m² im textilen Herzen Kataloniens', body: 'Design, Separation, Rotation, Flach, Musterbau und Glas — alles unter einem Dach.' },
      ],
      facilitiesKicker: 'Anlagen',
      facilitiesTitle: '1.000 m² im textilen Herzen des Maresme.',
      facilitiesBody:
        'Design, Separation, Rotationsgravur, Flachgravur, digitales Mustern, 3D-Mapping und Glas — alles in derselben Halle. Diese Integration erlaubt Reaktionszeiten in Stunden, nicht Wochen.',
    },
    international: {
      kicker: 'Internationaler Service',
      title: 'Ein katalanisches Unternehmen mit Kunden auf vier Kontinenten.',
      intro:
        'Seit über zehn Jahren übertragen wir unser Know-how an Werkstätten und Marken außerhalb Spaniens. Mit einem klaren Ziel: dass ein Druck, der 9.000 km entfernt entsteht, denselben Standard hat wie der aus Vilassar.',
      regions: [
        { name: 'Europa', body: 'Lokale Produktion für italienische, französische, portugiesische und deutsche Marken.' },
        { name: 'Asien', body: 'Technischer Transfer an Druckereien in der Türkei, Indien, China und Vietnam.' },
        { name: 'Afrika', body: 'Beratung und Qualitätsaudit für aufstrebende Textilcluster in Nord- und Westafrika.' },
        { name: 'Südamerika', body: 'Technische Begleitung für Werkstätten in Brasilien, Kolumbien und Peru.' },
      ],
      capabilitiesTitle: 'So arbeiten wir auf Distanz.',
      capabilities: [
        'Know-how-Transfer und Schulung technischer Teams vor Ort.',
        'Qualitätskontrolle für spanische Marken mit Auslandsproduktion.',
        'Audit und Feinabstimmung von Gravurräumen.',
        'Remote-Lieferung von Separationsdateien und produktionsfertigen Rapporten.',
      ],
    },
    sustainability: {
      kicker: 'F&E · Kreislaufwirtschaft',
      title: 'Wir machen Industrieabfall wieder zur Ressource.',
      intro:
        'Wir glauben nicht an Nachhaltigkeit auf dem Etikett. Wir glauben an geprüfte, ausgezeichnete Prozesse, die für jeden zurückgewonnenen Zylinder Tonnen CO₂ einsparen.',
      projects: [
        {
          code: 'TES/3340/2020',
          name: 'TAKE BACK RECILPACK',
          body:
            'Wiedergewinnung gebrauchter Anilox-Zylinder aus dem Verpackungsdruck mittels Hochdruck-Wasserwäsche, ohne Chemie. Mindestens 90 % der Mikrozellenkapazität werden zurückgewonnen — Einsparung von 1,4 t CO₂ pro Zylinder gegenüber Neuproduktion.',
          benefits: [
            'Ökologisch: nur Wasser, keinerlei Gefahrstoffe.',
            'Wirksam: ≥ 90 % Mikrozellen-Rückgewinnung.',
            'Wirtschaftlich: geringere Betriebskosten als bei klassischen Verfahren.',
            'Schnell: weniger Ausfallzeiten in der Druckstraße.',
          ],
        },
        {
          code: 'ACC/3352/2022',
          name: 'TAKE BACK SCREEN FLAT',
          body:
            'Rückgewinnungsprogramm für ausgemusterte Flachschablonen, die wieder in den textilen Druckprozess integriert werden. Ein zweites produktives Leben für ein Material, das bisher entsorgt wurde.',
          benefits: [
            'Geringerer Rohstoffverbrauch.',
            'Direkte Reduktion von Industrieabfall.',
            'Sofortige Wiederintegration in die Produktion.',
            'Vollständige Rückverfolgbarkeit.',
          ],
        },
      ],
      partnership:
        'Beide Projekte werden von der katalanischen Abfallagentur im Rahmen ihres Förderprogramms für Kreislaufwirtschaft unterstützt.',
    },
    contact: {
      kicker: 'Sprechen wir',
      title: 'Starten Sie ein Projekt mit uns.',
      intro:
        'Sagen Sie uns, was Sie gravieren, separieren oder bemustern möchten. Wir antworten binnen 24 Stunden mit einem konkreten Vorschlag.',
      form: {
        name: 'Name',
        email: 'E-Mail',
        company: 'Unternehmen',
        phone: 'Telefon',
        subject: 'Betreff',
        message: 'Nachricht',
        send: 'Nachricht senden',
        sending: 'Senden…',
        successTitle: 'Nachricht gesendet',
        successBody: 'Vielen Dank. Wir antworten innerhalb von 24 Stunden.',
        errorTitle: 'Versand nicht möglich',
        errorBody: 'Bitte erneut versuchen oder direkt an info@gravatsmaresme.com schreiben.',
        requiredName: 'Bitte geben Sie Ihren Namen ein.',
        requiredEmail: 'Bitte gültige E-Mail angeben.',
        requiredMessage: 'Sagen Sie uns, wie wir helfen können.',
      },
      info: {
        addressLabel: 'Adresse',
        address: 'C/ Manuel Ventura Campeny, 8\n08339 Vilassar de Dalt — Barcelona (Spanien)',
        phoneLabel: 'Telefon',
        emailLabel: 'E-Mail',
        hoursLabel: 'Öffnungszeiten',
        hours: 'Mo – Fr · 8:00 – 18:00 MEZ',
      },
    },
    footer: {
      tagline: 'Präzisionsdesign und Textilgravur. Seit 1981.',
      navTitle: 'Navigation',
      contactTitle: 'Kontakt',
      legalTitle: 'Rechtliches',
      privacy: 'Datenschutz',
      cookies: 'Cookies',
      rights: '© {year} Gravats Maresme, S.L. — Alle Rechte vorbehalten.',
      etrade: 'Projekt gefördert durch das Programm International e-Trade von ACCIÓ, Generalitat de Catalunya.',
    },
  },

  // ===================== ITALIAN =====================
  it: {
    meta: {
      title: 'Gravats Maresme — Incisione e design tessile di precisione dal 1981',
      description:
        'Oltre quarant’anni di incisione di cilindri rotativi e quadri piani per le industrie della stampa tessile e del vetro. Design, separazione colore, campionature, laser, LED, inkjet e consulenza internazionale.',
    },
    nav: {
      home: 'Home',
      about: 'Azienda',
      services: 'Servizi',
      international: 'Internazionale',
      sustainability: 'R&S',
      contact: 'Contatti',
      menu: 'Menu',
      close: 'Chiudi',
    },
    cta: {
      contact: 'Contattaci',
      learnMore: 'Scopri di più',
      ourServices: 'I nostri servizi',
      requestInfo: 'Richiedi informazioni',
      getInTouch: 'Parliamone',
      explore: 'Esplora',
      viewAll: 'Vedi tutti',
    },
    home: {
      kicker: 'Vilassar de Dalt · Barcellona · Dal 1981',
      heroTitle: 'Precisione incisa in ogni metro di tessuto.',
      heroSub:
        'Quarant’anni di design e incisione di cilindri rotativi e quadri piani per i marchi più esigenti del tessile e del vetro.',
      heroLine1: 'Design tessile · Incisione rotativa · Vetro architettonico',
      stats: [
        { num: '1981', label: 'Anno di fondazione' },
        { num: '40+', label: 'Anni di esperienza' },
        { num: '1.000 m²', label: 'Impianto tecnico' },
        { num: '4', label: 'Continenti serviti' },
      ],
      introKicker: 'Chi siamo',
      introTitle: 'Una manifattura tecnica al servizio del design.',
      introBody:
        'Gravats Maresme nasce nel 1981 alle porte di Barcellona, nel cuore della tradizione tessile catalana. Quarant’anni dopo continuiamo a integrare design, incisione e campionatura sotto lo stesso tetto — esportando il nostro know-how in Asia, Africa, Europa e America.',
      servicesKicker: 'Specialità',
      servicesTitle: 'Un partner al tuo fianco, dal primo schizzo al rapport finale.',
      servicesIntro:
        'Sensibilità di design e tecnologia di incisione all’avanguardia: laser, LED, inkjet e software di separazione proprietario.',
      techKicker: 'Tecnologia',
      techTitle: 'Macchine pensate per il prossimo decennio, non per il precedente.',
      techBody:
        'Laser ad alta risoluzione, scansione LED senza pellicola, macchine inkjet piane fino a 4.000 × 7.000 mm e due impianti LED per rotativa di qualsiasi rapport.',
      intlKicker: 'Servizio internazionale',
      intlTitle: 'Dove c’è una linea di stampa, ci siamo.',
      intlBody:
        'Da oltre dieci anni accompagniamo stamperie in Asia, Africa e Sud America al livello qualitativo europeo, e controlliamo la produzione di marchi spagnoli che stampano all’estero.',
      sustainKicker: 'R&S · Economia circolare',
      sustainTitle: 'Recuperiamo ciò che l’industria scartava.',
      sustainBody:
        'Con il sostegno dell’Agenzia dei Rifiuti della Catalogna abbiamo sviluppato due processi pionieristici — TAKE BACK RECILPACK e TAKE BACK SCREEN FLAT — che riportano cilindri e quadri usati alla loro vita produttiva.',
      finalCtaKicker: 'Parliamone',
      finalCtaTitle: 'Il tuo prossimo design merita un’incisione all’altezza.',
      finalCtaBody:
        'Raccontaci a cosa stai lavorando. Risponderemo entro 24 ore con una proposta tecnica chiara.',
    },
    services: {
      kicker: 'I nostri servizi',
      title: 'Design, incisione e ingegneria tessile sotto un unico tetto.',
      intro:
        'Sette specialità coordinate verticalmente per portare il tuo progetto sul mercato più rapidamente, meglio e con maggiore sostenibilità.',
      items: [
        { n: '01', title: 'Design tessile e originali', body: 'Designer interni con software dedicato, presenza costante alle fiere internazionali e radar sempre acceso sulle tendenze.' },
        { n: '02', title: 'Incisione rotativa', body: 'Cilindri rotativi incisi con laser e LED, capaci di riprodurre rapport complessi con costanza millimetrica.' },
        { n: '03', title: 'Incisione piana e inkjet', body: 'Macchine inkjet piane fino a 4.000 × 7.000 mm per quadri di qualsiasi formato — inclusa serigrafia tecnica di alta precisione.' },
        { n: '04', title: 'Separazione colore e rapport', body: 'Software proprietario per separare, calibrare e validare le varianti cromatiche. File pronti per la produzione.' },
        { n: '05', title: 'Campionature, digitale e 3D mapping', body: 'Reparto interno per campioni fisici, sublimazione digitale e 3D mapping per anteprima del capo stampato.' },
        { n: '06', title: 'Vetro architettonico e automotive', body: 'Divisione dedicata alla serigrafia su vetro, tecnologia LED senza pellicola fino a 4.000 × 7.000 mm.' },
        { n: '07', title: 'Consulenza e controllo qualità', body: 'Oltre dieci anni di trasferimento di know-how a stamperie internazionali e audit qualità per marchi spagnoli.' },
      ],
    },
    about: {
      kicker: 'L’azienda',
      title: 'Quarant’anni a fare dell’incisione un mestiere di precisione.',
      intro:
        'Fondata nel 1981 a Vilassar de Dalt, alle porte di Barcellona, Gravats Maresme è nata nel cuore di una delle aree tessili più attive d’Europa. Da allora facciamo una sola cosa molto bene: incidere quadri e disegnare, perché i grandi nomi del tessile possano stampare meglio.',
      timelineTitle: 'Una storia di macchine, mani e alba.',
      timeline: [
        { year: '1981', title: 'Fondazione a Vilassar de Dalt', body: 'Nasciamo come piccolo laboratorio specializzato in incisione lionese e rotativa per le stamperie del Maresme.' },
        { year: '1995', title: 'Integrazione verticale', body: 'Apriamo il reparto interno di design e separazione colore: il rapport esce dalla casa pronto per la produzione.' },
        { year: '2008', title: 'Apertura internazionale', body: 'Iniziamo a supportare stamperie in Asia, Africa e Sud America verso gli standard di qualità europei.' },
        { year: '2015', title: 'Tecnologie laser e LED', body: 'Rinnoviamo l’intero parco macchine: incisione laser e LED senza pellicola fino a 4.000 × 7.000 mm.' },
        { year: '2020', title: 'R&S ed economia circolare', body: 'Con l’Agenzia dei Rifiuti della Catalogna lanciamo TAKE BACK RECILPACK e TAKE BACK SCREEN FLAT.' },
        { year: 'Oggi', title: '1.000 m² nel cuore tessile della Catalogna', body: 'Design, separazione, rotativa, piano, campionatura e vetro: tutto sotto lo stesso tetto.' },
      ],
      facilitiesKicker: 'Impianti',
      facilitiesTitle: '1.000 m² nel cuore tessile del Maresme.',
      facilitiesBody:
        'Design, separazione, incisione rotativa, incisione piana, campionatura digitale, 3D mapping e vetro: tutto nello stesso stabilimento. Questa integrazione ci permette di rispondere in ore, non in settimane.',
    },
    international: {
      kicker: 'Servizio internazionale',
      title: 'Un’azienda catalana con clienti in quattro continenti.',
      intro:
        'Da oltre dieci anni trasferiamo il nostro know-how a stamperie e marchi oltre la Spagna. Con un obiettivo chiaro: che ciò che si stampa a 9.000 km abbia lo stesso standard di ciò che esce da Vilassar.',
      regions: [
        { name: 'Europa', body: 'Produzione locale con marchi italiani, francesi, portoghesi e tedeschi.' },
        { name: 'Asia', body: 'Trasferimento tecnico a stamperie in Turchia, India, Cina e Vietnam.' },
        { name: 'Africa', body: 'Consulenza e audit qualità per i poli tessili emergenti del Nord e Ovest Africa.' },
        { name: 'Sud America', body: 'Supporto tecnico a stamperie in Brasile, Colombia e Perù.' },
      ],
      capabilitiesTitle: 'Come lavoriamo a distanza.',
      capabilities: [
        'Trasferimento di know-how e formazione dei team tecnici in loco.',
        'Controllo qualità per i marchi spagnoli che stampano all’estero.',
        'Audit e messa a punto delle sale incisione.',
        'Consegna remota dei file di separazione e dei rapport pronti per la produzione.',
      ],
    },
    sustainability: {
      kicker: 'R&S · Economia circolare',
      title: 'Trasformiamo il rifiuto industriale in risorsa produttiva.',
      intro:
        'Non crediamo nella sostenibilità da etichetta. Crediamo in processi verificati, premiati dall’Agenzia dei Rifiuti della Catalogna, che fanno risparmiare tonnellate di CO₂ per ogni cilindro recuperato.',
      projects: [
        {
          code: 'TES/3340/2020',
          name: 'TAKE BACK RECILPACK',
          body:
            'Recupero dei cilindri anilox usati nella stampa di packaging mediante lavaggio ad acqua in pressione, senza prodotti chimici. Recupero minimo del 90% della capacità delle microcelle e risparmio di 1,4 tonnellate di CO₂ per cilindro rispetto a uno nuovo.',
          benefits: [
            'Ecologico: solo acqua, zero rifiuti pericolosi.',
            'Efficace: ≥ 90% delle microcelle recuperate.',
            'Economico: costi operativi inferiori rispetto ai metodi tradizionali.',
            'Veloce: meno fermi sulla linea di stampa.',
          ],
        },
        {
          code: 'ACC/3352/2022',
          name: 'TAKE BACK SCREEN FLAT',
          body:
            'Programma di recupero dei quadri piani in disuso per reinserirli nel processo di stampa tessile. Una seconda vita produttiva per un materiale tradizionalmente scartato.',
          benefits: [
            'Minor consumo di materie prime.',
            'Riduzione diretta dei rifiuti industriali.',
            'Reintegrazione immediata in produzione.',
            'Tracciabilità completa del ciclo.',
          ],
        },
      ],
      partnership:
        'Entrambi i progetti sono sostenuti dall’Agenzia dei Rifiuti della Catalogna nell’ambito del programma di aiuti per l’economia circolare.',
    },
    contact: {
      kicker: 'Parliamone',
      title: 'Inizia un progetto con noi.',
      intro:
        'Raccontaci cosa devi incidere, separare o campionare. Risponderemo entro 24 ore con una proposta concreta.',
      form: {
        name: 'Nome',
        email: 'Email',
        company: 'Azienda',
        phone: 'Telefono',
        subject: 'Oggetto',
        message: 'Messaggio',
        send: 'Invia messaggio',
        sending: 'Invio…',
        successTitle: 'Messaggio inviato',
        successBody: 'Grazie. Risponderemo entro 24 ore.',
        errorTitle: 'Invio non riuscito',
        errorBody: 'Riprova o scrivici direttamente a info@gravatsmaresme.com.',
        requiredName: 'Indica il tuo nome.',
        requiredEmail: 'Inserisci un’email valida.',
        requiredMessage: 'Dicci come possiamo aiutare.',
      },
      info: {
        addressLabel: 'Indirizzo',
        address: 'C/ Manuel Ventura Campeny, 8\n08339 Vilassar de Dalt — Barcellona (Spagna)',
        phoneLabel: 'Telefono',
        emailLabel: 'Email',
        hoursLabel: 'Orari',
        hours: 'Lun – Ven · 8:00 – 18:00 CET',
      },
    },
    footer: {
      tagline: 'Design e incisione tessile di precisione. Dal 1981.',
      navTitle: 'Navigazione',
      contactTitle: 'Contatti',
      legalTitle: 'Legale',
      privacy: 'Informativa sulla privacy',
      cookies: 'Cookie',
      rights: '© {year} Gravats Maresme, S.L. — Tutti i diritti riservati.',
      etrade: 'Progetto sostenuto dal Programma International e-Trade di ACCIÓ, Generalitat de Catalunya.',
    },
  },
};
